export const BILLING_ALL_RECORDS_REQUEST = 'BILLING_ALL_RECORDS_REQUEST';
export const BILLING_ALL_RECORDS_SUCCESS = 'BILLING_ALL_RECORDS_SUCCESS';
export const BILLING_ALL_RECORDS_FAIL = 'BILLING_ALL_RECORDS_FAIL';

export const BILLING_SUBMIT_REQUEST = 'BILLING_SUBMIT_REQUEST';
export const BILLING_SUBMIT_SUCCESS = 'BILLING_SUBMIT_SUCCESS';
export const BILLING_SUBMIT_FAIL = 'BILLING_SUBMIT_FAIL';
export const BILLING_SUBMIT_RESET = 'BILLING_SUBMIT_RESET';

export const BILLING_BULK_UPDATE_REQUEST = 'BILLING_BULK_UPDATE_REQUEST';
export const BILLING_BULK_UPDATE_SUCCESS = 'BILLING_BULK_UPDATE_SUCCESS';
export const BILLING_BULK_UPDATE_FAIL = 'BILLING_BULK_UPDATE_FAIL';
export const BILLING_BULK_UPDATE_RESET = 'BILLING_BULK_UPDATE_RESET';

export const BILLING_SUPERVISOR_BANKS_REQUEST = 'BILLING_SUPERVISOR_BANKS_REQUEST';
export const BILLING_SUPERVISOR_BANKS_SUCCESS = 'BILLING_SUPERVISOR_BANKS_SUCCESS';
export const BILLING_SUPERVISOR_BANKS_FAIL = 'BILLING_SUPERVISOR_BANKS_FAIL';

export const BILLING_STATUS_UPDATE_REQUEST = 'BILLING_STATUS_UPDATE_REQUEST';
export const BILLING_STATUS_UPDATE_SUCCESS = 'BILLING_STATUS_UPDATE_SUCCESS';
export const BILLING_STATUS_UPDATE_FAIL = 'BILLING_STATUS_UPDATE_FAIL';
export const BILLING_STATUS_UPDATE_RESET = 'BILLING_STATUS_UPDATE_RESET';

export const BILLING_MASTER_LIST_REQUEST = 'BILLING_MASTER_LIST_REQUEST';
export const BILLING_MASTER_LIST_SUCCESS = 'BILLING_MASTER_LIST_SUCCESS';
export const BILLING_MASTER_LIST_FAIL = 'BILLING_MASTER_LIST_FAIL';

export const BILLING_MASTER_CREATE_REQUEST = 'BILLING_MASTER_CREATE_REQUEST';
export const BILLING_MASTER_CREATE_SUCCESS = 'BILLING_MASTER_CREATE_SUCCESS';
export const BILLING_MASTER_CREATE_FAIL = 'BILLING_MASTER_CREATE_FAIL';
export const BILLING_MASTER_CREATE_RESET = 'BILLING_MASTER_CREATE_RESET';

export const BILLING_MASTER_UPDATE_REQUEST = 'BILLING_MASTER_UPDATE_REQUEST';
export const BILLING_MASTER_UPDATE_SUCCESS = 'BILLING_MASTER_UPDATE_SUCCESS';
export const BILLING_MASTER_UPDATE_FAIL = 'BILLING_MASTER_UPDATE_FAIL';
export const BILLING_MASTER_UPDATE_RESET = 'BILLING_MASTER_UPDATE_RESET';

export const BILLING_MASTER_DELETE_REQUEST = 'BILLING_MASTER_DELETE_REQUEST';
export const BILLING_MASTER_DELETE_SUCCESS = 'BILLING_MASTER_DELETE_SUCCESS';
export const BILLING_MASTER_DELETE_FAIL = 'BILLING_MASTER_DELETE_FAIL';
export const BILLING_MASTER_DELETE_RESET = 'BILLING_MASTER_DELETE_RESET';

export const BILLING_MASTER_BULK_DELETE_REQUEST = 'BILLING_MASTER_BULK_DELETE_REQUEST';
export const BILLING_MASTER_BULK_DELETE_SUCCESS = 'BILLING_MASTER_BULK_DELETE_SUCCESS';
export const BILLING_MASTER_BULK_DELETE_FAIL = 'BILLING_MASTER_BULK_DELETE_FAIL';
export const BILLING_MASTER_BULK_DELETE_RESET = 'BILLING_MASTER_BULK_DELETE_RESET';
